/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const couponKind = {
  'COUPON-PAYING': 'COUPON-PAYING',
  'PRINCIPAL-ONLY': 'PRINCIPAL-ONLY',
} as const

export type CouponKind = (typeof couponKind)[keyof typeof couponKind]
